import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceReportUpdate from './InsuranceReportUpdate';
import { Size } from '../../../../Enums/Size.enum';
import { InsuranceReport } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	insuranceReport: InsuranceReport;
	onUpdate: () => void;
}

const InsuranceReportUpdateModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.insuranceReportUpdate.title'
			size={Size.MD}
			{...props}>
			<InsuranceReportUpdate
				onUpdate={props.onUpdate}
				insuranceReport={props.insuranceReport}
			/>
		</BaseModal>
	);
};

export default InsuranceReportUpdateModal;
